export const loadedSiteData = ({ pages, blogs, meta }) => {
  return {
    payload: { pages, blogs, meta },
    type: 'content/LOADED_SITE_DATA'
  };
};

export const pageUpdated = (page) => {
  return {
    payload: { page },
    type: 'content/PAGE_UPDATED'
  };
};

export const pageDeleted = (pageId) => {
  return {
    payload: { pageId },
    type: 'content/PAGE_DELETED'
  }
}

export const pageAdded = (page) => {
  return {
    payload: { page },
    type: 'content/PAGE_ADDED'
  };
};

export const blogUpdated = (blog) => {
  return {
    payload: { blog },
    type: 'content/BLOG_UPDATED'
  };
};

export const blogDeleted = (blogId) => {
  return {
    payload: { blogId },
    type: 'content/BLOG_DELETED'
  }
}

export const blogRenamed = (oldBlogId, newBlogId) => {
  return {
    payload: { oldBlogId, newBlogId },
    type: 'content/BLOG_RENAMED'
  };
};

export const blogAdded = (blog) => {
  return {
    payload: { blog },
    type: 'content/BLOG_ADDED'
  };
};

export const contentSectionUpdated = (pageId, section) => {
  return {
    payload: { pageId, section },
    type: 'content/SECTION_UPDATED'
  }
};



// WEBPACK FOOTER //
// ./client/RLX/State/Content/ContentCreators.js